import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { renderBlocksHtml, SAMPLE_CONTACT } from "@/lib/emailBlocks";
import { FileText, Trash2, PencilRuler } from "lucide-react";

export default function TemplatesPage() {
  const [items, setItems] = useState(null);
  const navigate = useNavigate();

  const load = () => api.get("/templates").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    await api.delete(`/templates/${id}`);
    toast.success("Template deleted");
    load();
  };

  return (
    <div className="space-y-6">
      <div>
        <p className="text-xs font-mono uppercase tracking-widest text-indigo-400 mb-1">Reusable email designs</p>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-50">Templates</h1>
      </div>

      {items === null ? null : items.length === 0 ? (
        <div className="bg-[#111827] border border-slate-800 rounded-xl p-12 text-center" data-testid="templates-empty">
          <FileText size={32} className="mx-auto text-slate-600 mb-3" />
          <p className="text-slate-400">No templates yet. Design an email campaign and click "Save template".</p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((t) => (
            <div key={t.id} data-testid="template-card" className="stat-card overflow-hidden flex flex-col fade-up">
              <div className="h-44 overflow-hidden bg-slate-100 relative">
                <div className="scale-[0.55] origin-top-left w-[182%] pointer-events-none p-4" dangerouslySetInnerHTML={{ __html: renderBlocksHtml(t.blocks, SAMPLE_CONTACT) }} />
                <div className="absolute inset-0 bg-gradient-to-t from-[#111827] via-transparent to-transparent" />
              </div>
              <div className="p-4 flex items-center justify-between">
                <div className="min-w-0">
                  <div className="font-heading font-semibold text-slate-100 truncate">{t.name}</div>
                  {t.subject && <div className="text-xs text-slate-500 truncate">"{t.subject}"</div>}
                </div>
                <div className="flex gap-1 shrink-0">
                  <Button data-testid="template-use-button" size="sm" onClick={() => navigate(`/email-campaigns/new?template=${t.id}`)} className="bg-indigo-500 hover:bg-indigo-600 text-white h-8">
                    <PencilRuler size={13} className="mr-1.5" /> Use
                  </Button>
                  <button data-testid="template-delete-button" onClick={() => remove(t.id)} className="text-slate-500 hover:text-rose-400 p-1.5"><Trash2 size={14} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
